import {
  DocumentTemplateFontEnum,
  DocumentTemplateLayoutEnum,
  TagColorEnum,
} from "@/__generated__/graphql";

/** What an invoice is drawn with: its template's look and what it tells the payer. */
export type InvoiceTemplate = {
  layout?: DocumentTemplateLayoutEnum | null;
  font?: DocumentTemplateFontEnum | null;
  color?: TagColorEnum | null;
  paymentInstructions?: string | null;
  footer?: string | null;
};

/**
 * A template's typeface on screen, and in its PDF: the three @react-pdf draws
 * without a font file registered. Sans serif on screen is the app's own Inter,
 * each weight of which is a face of its own the theme picks per level.
 */
export const TEMPLATE_FONTS = {
  [DocumentTemplateFontEnum.Sans]: {
    screen: null,
    pdf: "Helvetica",
    pdfBold: "Helvetica-Bold",
  },
  [DocumentTemplateFontEnum.Serif]: {
    screen: 'Georgia, "Times New Roman", serif',
    pdf: "Times-Roman",
    pdfBold: "Times-Bold",
  },
  [DocumentTemplateFontEnum.Mono]: {
    screen: 'ui-monospace, "SF Mono", Menlo, Consolas, monospace',
    pdf: "Courier",
    pdfBold: "Courier-Bold",
  },
};

/** The words every invoice prints whatever it says: the canvas's and its PDF's. */
export const INVOICE_LABELS = {
  title: "Invoice",
  number: "Invoice number",
  issued: "Issue date",
  billedTo: "Billed to",
  issuedBy: "Issued by",
  columns: ["Product or service", "Quantity", "Unit price", "Tax", "Total"],
  noLines: "No line items",
  waysToPay: "Ways to pay",
  eTransfer: "E-transfer",
  card: "Pay by card online",
  scan: "or scan the QR code with your phone",
};
